(() => {
  'use strict';
  const config = window.VorlenTheme || {};
  const routes = config.routes || {};
  const root = routes.root || '/';
  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => [...scope.querySelectorAll(selector)];
  let cartBusy = false;
  let cartRevision = 0;
  let toastTimer;

  function announce(message) {
    const toast = $('#toast');
    if (!toast) return;
    clearTimeout(toastTimer);
    toast.textContent = message;
    toast.classList.add('visible');
    toastTimer = setTimeout(() => toast.classList.remove('visible'), 4200);
  }
  function openDialog(id) {
    const dialog = document.getElementById(id);
    if (!dialog || dialog.open || typeof dialog.showModal !== 'function') return false;
    dialog.showModal();
    document.body.classList.add('dialog-open');
    if (id === 'search-dialog') $('#SearchDialogInput')?.focus();
    return true;
  }
  function setFormError(form, message) {
    const el = $('[data-form-error]', form);
    if (!el) return;
    el.textContent = message;
    el.hidden = !message;
  }
  function renderCartSections(sections) {
    const html = sections?.['cart-drawer'];
    if (typeof html !== 'string') return false;
    const fragment = new DOMParser().parseFromString(html, 'text/html');
    const incoming = fragment.getElementById('CartContents');
    const current = $('#CartContents');
    if (!incoming || !current) return false;
    current.replaceWith(incoming);
    $$('[data-cart-count]').forEach(node => { node.textContent = incoming.dataset.count || '0'; });
    return true;
  }
  async function refreshCart() {
    const revision = cartRevision;
    const url = new URL(window.location.href);
    url.searchParams.set('sections', 'cart-drawer');
    const response = await fetch(url.toString(), { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('تعذّر تحديث الحقيبة. افتح صفحة الحقيبة للمراجعة.');
    const sections = await response.json();
    if (revision !== cartRevision) return;
    if (!renderCartSections(sections)) throw new Error('تعذّر عرض الحقيبة. افتح صفحة الحقيبة للمراجعة.');
  }
  function normalizedQuantity(input, delta = 0) {
    const min = Math.max(1, Number(input.min) || 1);
    const step = Math.max(1, Number(input.step) || 1);
    const requestedMax = input.max ? Math.max(min, Number(input.max)) : Number.MAX_SAFE_INTEGER;
    const max = min + Math.floor((requestedMax - min) / step) * step;
    let value = Math.max(min, Number(input.value) || min);
    value = min + Math.round((value - min) / step) * step + delta * step;
    value = Math.min(max, Math.max(min, value));
    input.value = value;
    const form = input.closest('form');
    const minus = $('[data-product-quantity="minus"]', form);
    const plus = $('[data-product-quantity="plus"]', form);
    if (minus) minus.disabled = value <= min;
    if (plus) plus.disabled = value + step > max;
    return value;
  }
  function syncVariant(select) {
    const option = select.selectedOptions[0];
    const surface = select.closest('[data-product-surface]');
    if (!option || !surface) return;
    const available = option.dataset.available === 'true';
    const onSale = option.dataset.onSale === 'true';
    $('[data-current-price]', surface).textContent = option.dataset.price;
    const compare = $('[data-compare-price]', surface);
    compare.textContent = option.dataset.compare;
    compare.hidden = !onSale;
    const saving = $('[data-saving]', surface);
    saving.textContent = `وفّر ${option.dataset.saving}`;
    saving.hidden = !onSale;
    $('[data-availability]', surface).textContent = available ? 'متوفر للطلب' : 'نفدت الكمية';
    $('[data-add-label]', surface).textContent = available ? 'أضف إلى الحقيبة' : 'نفدت الكمية';
    $$('[data-add-button], [data-buy-now]', surface).forEach(button => { button.disabled = !available; });
    const quantity = $('input[name="quantity"]', surface);
    quantity.min = option.dataset.min || '1';
    quantity.step = option.dataset.step || '1';
    if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
    normalizedQuantity(quantity);
    if (option.dataset.image) {
      const image = $('.main-product-image', surface);
      if (image) { image.removeAttribute('srcset'); image.src = option.dataset.image; }
    }
    const mobilePrice = $('[data-mobile-price]', surface.parentElement);
    if (mobilePrice) mobilePrice.textContent = option.dataset.price;
    setFormError(select.closest('form'), '');
    if (document.body.classList.contains('template-product')) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', select.value);
      window.history.replaceState({}, '', url);
    }
  }

  document.addEventListener('submit', async event => {
    const form = event.target.closest('.product-form');
    if (!form) return;
    event.preventDefault();
    if (cartBusy || form.dataset.submitting === 'true') return;
    if (!form.reportValidity()) return;
    const button = event.submitter || $('[data-add-button]', form);
    if (button?.disabled) return;
    const buyNow = button?.hasAttribute('data-buy-now');
    normalizedQuantity($('input[name="quantity"]', form));
    const body = new FormData(form);
    body.set('sections', 'cart-drawer');
    body.set('sections_url', window.location.pathname);
    body.delete('return_to');
    body.delete('add');
    setFormError(form, '');
    form.dataset.submitting = 'true';
    cartBusy = true;
    cartRevision += 1;
    form.classList.add('is-loading');
    form.setAttribute('aria-busy', 'true');
    const submitButtons = $$('button, select, input', form);
    const oldStates = submitButtons.map(el => el.disabled);
    submitButtons.forEach(el => { el.disabled = true; });
    try {
      const response = await fetch(`${routes.add || root + 'cart/add'}.js`, { method: 'POST', body, credentials: 'same-origin', headers: { Accept: 'application/json' } });
      const result = await response.json();
      if (!response.ok || result.status >= 400) {
        setFormError(form, typeof result.description === 'string' ? result.description : 'تعذّرت إضافة هذه الكمية. راجع التوفر وحاول مرة أخرى.');
        return;
      }
      if (buyNow) {
        const checkout = $('#QuickCheckoutForm');
        if (checkout) checkout.submit(); else window.location.assign(routes.cart || root + 'cart');
        return;
      }
      let rendered = renderCartSections(result.sections);
      if (!rendered) { try { await refreshCart(); rendered = true; } catch { /* The order was added. Never submit it twice. */ } }
      if (rendered && openDialog('cart-dialog')) return;
      window.location.assign(routes.cart || root + 'cart');
    } catch {
      setFormError(form, 'تعذّر تأكيد الإضافة. افتح الحقيبة للتحقق قبل المحاولة مجددًا.');
    } finally {
      form.dataset.submitting = 'false';
      cartBusy = false;
      form.classList.remove('is-loading');
      form.removeAttribute('aria-busy');
      submitButtons.forEach((el, i) => { el.disabled = oldStates[i]; });
    }
  });

  async function changeCart(button) {
    if (cartBusy) return;
    cartBusy = true;
    cartRevision += 1;
    const contents = $('#CartContents');
    contents?.classList.add('is-loading');
    const error = $('#CartError');
    if (error) error.hidden = true;
    try {
      const response = await fetch(`${routes.change || root + 'cart/change'}.js`, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: button.dataset.key, quantity: Math.max(0, Number(button.dataset.quantity) || 0), sections: ['cart-drawer'], sections_url: window.location.pathname }) });
      const result = await response.json();
      if (!response.ok || result.status >= 400) throw new Error(typeof result.description === 'string' ? result.description : typeof result.message === 'string' ? result.message : 'هذه الكمية غير متاحة حاليًا.');
      if (!renderCartSections(result.sections)) await refreshCart();
    } catch (reason) {
      const message = reason instanceof TypeError ? 'تعذّر تأكيد التحديث. افتح صفحة الحقيبة للتحقق.' : reason.message;
      const visibleError = $('#CartError');
      if (visibleError) { visibleError.textContent = message; visibleError.hidden = false; } else announce(message);
    } finally {
      cartBusy = false;
      $('#CartContents')?.classList.remove('is-loading');
      contents?.classList.remove('is-loading');
    }
  }

  document.addEventListener('click', event => {
    const open = event.target.closest('[data-open]');
    if (open) {
      if (openDialog(open.dataset.open)) {
        event.preventDefault();
        if (open.dataset.open === 'cart-dialog' && !cartBusy) refreshCart().catch(() => announce('تعذّر تحديث العرض. يمكنك مراجعة الحقيبة من صفحة الحقيبة.'));
      }
      return;
    }
    const close = event.target.closest('[data-close]');
    if (close) { close.closest('dialog')?.close(); return; }
    const cartChange = event.target.closest('[data-cart-change]');
    if (cartChange) { event.preventDefault(); changeCart(cartChange); return; }
    const quantity = event.target.closest('[data-product-quantity]');
    if (quantity) { const input = $('input[name="quantity"]', quantity.closest('form')); if (input) normalizedQuantity(input, quantity.dataset.productQuantity === 'plus' ? 1 : -1); return; }
    const thumbnail = event.target.closest('[data-gallery-image]');
    if (thumbnail) {
      const surface = thumbnail.closest('[data-product-surface]');
      const image = $('.main-product-image', surface);
      if (image) { image.removeAttribute('srcset'); image.src = thumbnail.dataset.galleryImage; image.alt = thumbnail.dataset.imageAlt; }
      $$('[data-gallery-image]', surface).forEach(item => { item.classList.toggle('selected', item === thumbnail); item.setAttribute('aria-pressed', String(item === thumbnail)); });
      return;
    }
    const expand = event.target.closest('[data-expand]');
    if (expand) {
      const source = $('.main-product-image', expand.closest('[data-product-surface]'));
      const target = $('#enlarged-image');
      if (source && target) { target.src = source.currentSrc || source.src; target.alt = source.alt; openDialog('image-dialog'); }
    }
    const mood = event.target.closest('[data-mood]');
    if (mood) selectMood(mood);
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-variant-select]')) syncVariant(event.target);
    if (event.target.matches('.product-form input[name="quantity"]')) normalizedQuantity(event.target);
  });

  const moods = {
    warm: ['01', 'للحظات التي تستحق الهدوء.', 'إضاءة دافئة لأمسيات مريحة، وحديث لطيف، وفنجان أخير قبل نهاية اليوم.'],
    natural: ['02', 'للتفاصيل التي تحبّ أن تراها.', 'إضاءة طبيعية متوازنة، ترافق روتينك اليومي وتنسجم مع ركنك المفضّل.'],
    white: ['03', 'حين تحتاج إلى مزيد من الوضوح.', 'إضاءة بيضاء لجو أكثر إشراقًا، تختارها متى احتجت إلى تغيير إحساس المكان.']
  };
  function selectMood(button) {
    const area = button.closest('.mood-content');
    const mood = moods[button.dataset.mood];
    if (!area || !mood) return;
    $$('[data-mood]', area).forEach(tab => { const active = tab === button; tab.classList.toggle('active', active); tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1; });
    $('[role="tabpanel"]', area).setAttribute('aria-labelledby', button.id);
    $('[data-mood-number]', area).textContent = mood[0];
    $('[data-mood-name]', area).textContent = mood[1];
    $('[data-mood-description]', area).textContent = mood[2];
  }
  document.addEventListener('keydown', event => {
    const button = event.target.closest('[data-mood]');
    if (!button) return;
    const tabs = $$('[data-mood]', button.closest('[role="tablist"]'));
    const index = tabs.indexOf(button);
    const next = event.key === 'ArrowLeft' ? (index + 1) % tabs.length : event.key === 'ArrowRight' ? (index + tabs.length - 1) % tabs.length : event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : -1;
    if (next < 0) return;
    event.preventDefault();
    selectMood(tabs[next]);
    tabs[next].focus();
  });
  function init(scope = document) {
    $$('dialog', scope).forEach(dialog => {
      if (dialog.dataset.ready) return;
      dialog.dataset.ready = 'true';
      dialog.addEventListener('close', () => { if (!$('dialog[open]')) document.body.classList.remove('dialog-open'); });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
      });
    });
    $$('.product-form input[name="quantity"]', scope).forEach(input => normalizedQuantity(input));
    $$('[data-native-mobile-buy]', scope).forEach(bar => {
      if (bar.dataset.ready) return;
      bar.dataset.ready = 'true';
      let productVisible = false;
      const update = () => bar.classList.toggle('visible', window.scrollY > 450 && !productVisible);
      const form = document.getElementById(bar.dataset.formId);
      if ('IntersectionObserver' in window && form) new IntersectionObserver(entries => { productVisible = entries[0].isIntersecting; update(); }, { threshold: .1 }).observe(form);
      window.addEventListener('scroll', update, { passive: true });
      update();
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', () => { if (!$('dialog[open]')) document.body.classList.remove('dialog-open'); });
})();
